import {useQuery} from '@apollo/client';
import { GET_COVER_PRODUCTS } from '../../Queries/products';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const UseGetAllCoverProducts = (
    selectedExcludedProducts,
    lang,
    coverID,
    SetFormData
) => {

    const [variables,SetVariables] = useState({
        lang,
        coverID
    });

    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedProductIDs,SetSelectedProductIDs] = useState((selectedExcludedProducts ? selectedExcludedProducts : []));

    const {data,loading,error} = useQuery(GET_COVER_PRODUCTS,{
        variables,
        fetchPolicy:"network-only"
    })

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllCoverProducts);
            SetContent(contentData);
        }

    },[data])

    var headerData = [
        {
            value: t("ProductName"),
            className:"flex-1"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.name,
                        className:"flex-1"
                    }
                ]
            }

            if(selectedExcludedProducts.length > 0)
                cData.selected =  (selectedExcludedProducts.indexOf(val.productID) != -1 ? true : false); 
            else
                cData.selected = false;


            cData.rowID = val.productID;
            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,productID) => {

        SetSelectedProductIDs((prevVaue) => {

            var checked = e.target.checked;
            var newSelectedProductIDs = [...prevVaue];
            const newList = SelectProductID(content,productID,checked,newSelectedProductIDs)

            SetContent(newList);
            SetFormData("selectedExcludedProducts",newSelectedProductIDs);

            return newSelectedProductIDs;

        })
        
    }

    const SelectAll = (e) => {

        SetSelectedProductIDs(() => {

            var checked = e.target.checked;
            var newSelectedProductIDs = [];
            const newList = SelectProductID(content,"all",checked,newSelectedProductIDs)

            SetFormData("selectedExcludedProducts",newSelectedProductIDs);
            SetContent(newList);

            return newSelectedProductIDs;
        })
    }

    const SelectProductID = (list,productID,checked,selectedProductIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(productID == newList[i].rowID || productID === "all")
            {
                newList[i] = {...newList[i],selected:checked}
                if(checked)
                    selectedProductIDs.push(newList[i].rowID);
                else
                {
                    for(let j = 0; j < selectedProductIDs.length; j++)
                    {
                        if(selectedProductIDs[j] == newList[i].rowID)
                            selectedProductIDs.splice(j,1);  
                    } 
                }
            }

            if(newList[i].subData)
                newList[i] = {...newList[i],subData:SelectProductID(newList[i].subData,productID,checked,selectedProductIDs)}
        }

        return newList;
    }

    return{
        content,
        headerData,
        loading,
        error,
        selectedProductIDs,
        SelectRow,
        SelectAll
    }

}

export default UseGetAllCoverProducts;